import { GET_SETTLEMENTLIST, GET_SETTLEMENTDETAILS, GET_ADDSETTLEMENT, GET_UPDATESETTLEMENT ,GET_CONSOLIDATEDINVOICE} from "resources/actionTypes";

export function getSettlementList (settlementData){
  return{
    type: GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_REQUESTED,
    payload: settlementData
  };
}

export function getSettlementDetails (settlementPayload) {
  return {
   type: GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_REQUESTED,
   payload: settlementPayload
  }
}

export function addSettlement (settlementData,navigate){
  const data ={
    settlementData : settlementData,
    navigate:navigate,
  }
  return{
    type: GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_REQUESTED,
    payload:data,
  }
}

export function updateSettlement(updateSettlement){
  const data ={
    updateSettlementData : updateSettlement,
  }
  return{
    type: GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_REQUESTED,
    payload: data,
  };
}

export function getConsolidatedInvoiceList (consolidatedInvoice){
  return{
    type: GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_REQUESTED,
    payload: consolidatedInvoice
  };
}